import { Controller } from 'stimulus';
import { ezDebounce, triggerCustomEvent } from 'lib/helpers';

export default class ResourceDetailsController extends Controller {
  static targets = [
    'shareOptions',
    'descriptionWrapper',
    'description',
    'ellipsis',
  ];

  connect() {
    this.truncateDescription();

    window.addEventListener('resize', ezDebounce(() => {
      this.truncateDescription();
    }), 500);
  }

  truncateDescription() {
    if (this.descriptionTarget) {
      const numLines = 3;

      const descLineHeight = parseInt(getComputedStyle(this.descriptionWrapperTarget).lineHeight, 10);

      const targetDescHeight = descLineHeight * numLines;
      const curDescHeight = this.descriptionTarget.clientHeight;

      if (curDescHeight > targetDescHeight) {
        this.descriptionWrapperTarget.classList.add('is-truncated');
        this.ellipsisTarget.style.display = 'block';
      } else if (this.descriptionWrapperTarget.classList.contains('is-truncated')) {
        this.revealText();
      }
    }
  }

  revealText() {
    this.descriptionWrapperTarget.classList.remove('is-truncated');
    this.ellipsisTarget.style.display = 'none';
  }

  toggleShareOptions(event) {
    event.preventDefault();

    this.shareOptionsTarget.classList.toggle('is-expanded');
  }

  triggerCommentsPanel(event) {
    event.preventDefault();

    triggerCustomEvent('ToggleCommentsPanel');
  }
}
